module.exports = __webpack_public_path__ + "media/images/front/centres/office_castello-bebcfc3362190dd6fa0edb2f3c5d6146.webp";